import {
  type AlertErrorUpload,
  type DeleteFleetLogoRequest,
  FleetActionNames,
  type LoadFleetLogoUrlError,
  type LoadFleetLogoUrlRequest,
  type LoadFleetLogoUrlSucceeded,
  type UploadFleetLogo,
} from './actions';

export const uploadFleetLogo = (blob: Blob): UploadFleetLogo => ({
  type: FleetActionNames.UPLOAD_FLEET_LOGO,
  payload: blob,
});

export const loadFleetLogoUrlRequest = (fleetId: string): LoadFleetLogoUrlRequest => ({
  type: FleetActionNames.LOAD_FLEET_LOGO_URL_REQUEST,
  payload: fleetId,
});

export const loadFleetLogoUrlSucceeded = (fleetId: string | null): LoadFleetLogoUrlSucceeded => ({
  type: FleetActionNames.LOAD_FLEET_LOGO_URL_SUCCEEDED,
  payload: fleetId,
});

export const loadFleetLogoUrlFailed = (): LoadFleetLogoUrlError => ({
  type: FleetActionNames.LOAD_FLEET_LOGO_URL_FAILED,
});

export const alertErrorUpload = (error: Error): AlertErrorUpload => ({
  type: FleetActionNames.ERROR_ALERT_FLEET_LOGO,
  payload: error,
});

export const deleteFleetLogoRequest = (): DeleteFleetLogoRequest => ({
  type: FleetActionNames.DELETE_FLEET_LOGO_REQUEST,
});
